
<div class="accordion-item" *ngIf="anterior" [class]="readonly ? 'info-card m-0 p-0' : ''">
    <h2 class="accordion-header m-0">
        <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ipf-' + readonly + i">
            Frame Interdental papilla &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for front tooth {{dataService.rearrangedTeethOrder(teeth)}})</span>
        </button>
    </h2>

     <div id="ipf-{{readonly}}{{i}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
        <div class="accordion-body container text-center px-3 pt-2">
            <div class="radio-cards-container" style="max-width: 100%;" [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''">
       
               <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-front'+i] == 'Papilla-Free Design'">
                    <input [disabled]="readonly" type="radio" name="ipf-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-front'+i]" value="Papilla-Free Design" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml151"></app-magnifier>
                        <ng-template #apppropphtml151>
                        <div class="magnify-content"  style="padding-top: 13px;">
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_front_tooth_11_12_13/Papilla_free_design_2_C.png" />
                            </div>
                            <div class="card-text">Papilla-Free Design</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-front'+i] == 'Partially Open Papilla'">
                    <input [disabled]="readonly" type="radio" name="ipf-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-front'+i]" value="Partially Open Papilla" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml152"></app-magnifier>
                        <ng-template #apppropphtml152>
                        <div class="magnify-content"  style="padding-top: 13px;" >
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_front_tooth_11_12_13/Partially_open_papilla_2_C.png"  />
                            </div>
                            <div class="card-text">Partially Open Papilla</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-front'+i] == 'Closed Papilla Design'">
                    <input [disabled]="readonly" type="radio" name="ipf-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-front'+i]" value="Closed Papilla Design" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml153"></app-magnifier>
                        <ng-template #apppropphtml153>
                        <div class="magnify-content"  style="padding-top: 13px;">
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_front_tooth_11_12_13/Closed_papilla_Design_2_C.png"  />
                            </div>
                            <div class="card-text">Closed Papilla Design</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>

            </div>
           
        </div>
    </div>
</div>




<div class="accordion-item" *ngIf="!anterior" [class]="readonly ? 'info-card m-0 p-0' : ''">
    <h2 class="accordion-header m-0">
        <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ips-' + readonly + i">
            Frame Interdental papilla &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for side tooth {{dataService.rearrangedTeethOrder(teeth)}})</span>
        </button>
    </h2>


     <div id="ips-{{readonly}}{{i}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
        <div class="accordion-body container text-center px-3 pt-2">
            <div class="radio-cards-container" style="max-width: 100%;" [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''">
       
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-side'+i] == 'Papilla-Free Design'">
                    <input [disabled]="readonly" type="radio" name="ips-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-side'+i]" value="Papilla-Free Design" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml154"></app-magnifier>
                        <ng-template #apppropphtml154>
                             <div class="magnify-content"  style="padding-top: 13px;">
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_side_tooth_14, 15, 16, 17, 18/Papilla_free_design_C.png" />
                            </div>
                             <div class="card-text">Papilla-Free Design</div>
                             </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-side'+i] == 'Partially Open Papilla'">
                    <input [disabled]="readonly" type="radio" name="ips-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-side'+i]" value="Partially Open Papilla" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml155"></app-magnifier>
                        <ng-template #apppropphtml155>
                             <div class="magnify-content"  style="padding-top: 13px;">
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_side_tooth_14, 15, 16, 17, 18/Partially_open_papilla_C.png"/>
                             </div>
                            <div class="card-text">Partially Open Papilla</div>
                             </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['p-Interdental papilla-side'+i] == 'Closed Papilla Design'">
                    <input [disabled]="readonly" type="radio" name="ips-{{readonly}}{{i}}" [(ngModel)]="orderDetailsNew.props['p-Interdental papilla-side'+i]" value="Closed Papilla Design" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropphtml156"></app-magnifier>
                        <ng-template #apppropphtml156>
                             <div class="magnify-content"  style="padding-top: 13px;">
                             <div class="img-center">
                            <img class="p-3" width="auto" height="80" src="Asset_Image_Gity_V3/Interdental_Papilla/Copping/for_side_tooth_14, 15, 16, 17, 18/Closed_papilla_Design_C.png"/>
                            </div>
                            <div class="card-text">Closed Papilla Design</div>
                            </div>
                        </ng-template>
                    </div>   
                    <div class="radio-card-overlay"></div>
                </label>

            </div>
           
        </div>
    </div>
</div>
